<template>
  <div class="transition">
    <div class="transition-items">
      <div class="icon-items">
        <BasicIcon
          name="danger"
          active
        />
      </div>

      <BasicText>
        Cette entreprise n'est pas éligible à cette demande
      </BasicText>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
<style lang="less" scoped>
  @import './ChoixCarte.less';

  .icon-items {
    background-color: white;
    color: @warning-500;
    align-self: center;
    margin-bottom: 10px;
    svg {
      fill: @warning-500;
      transform: scale(3);
    }
  }
</style>
